let host=process.env.VUE_APP_MYHOST
export const config = {
  host: host,
  apiPath: 'sudportal',
  apiUrl: host+'sudportal/',
  cmsUrl: host+'unicorn/',
  authUrl: host+'sudportal/oauth/token',
  oneAuthUrl: host+'sudportal/oauth/code/',
  syncUrl: host+'sync/start/',
  syncUrlShort: host+'sync/',
  gasUrl: host+'gas/',
  confirmUrl: host+'sudportal/cabinet/confirm',
  passRestore: host+'sudportal/cabinet/restore',
  esiaPath: host + 'sudportal/gosuslugi'
}